import { Eyebrow, Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Confidence first",
    body: "Every Bailey story is a small act of self-belief — words children can carry out of the book and into their day.",
  },
  {
    n: "02",
    title: "Every child in the picture",
    body: "Representation matters. Bailey exists so every child can open a book and see someone who looks, laughs, and lives like them.",
  },
  {
    n: "03",
    title: "Big firsts, made gentle",
    body: "The first day of school. The first dentist chair. Milestones that feel enormous to a five-year-old — walked through hand in hand.",
  },
  {
    n: "04",
    title: "Everyday independence",
    body: "Getting dressed, helping at home, trying again. Bailey celebrates the small victories that grow into 'I can do it myself.'",
  },
  {
    n: "05",
    title: "A love of reading",
    body: "Stories written to be read aloud, returned to, and remembered — the kind that turn bedtime into the best part of the day.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-24 sm:py-32 bg-creamdark/50 border-y border-sand">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <Reveal className="lg:sticky lg:top-28">
              <Eyebrow className="mb-4">Our story</Eyebrow>
              <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-walnut mb-5">
                Why Bailey exists
              </h2>
              <p className="text-sm sm:text-base text-walnutsoft leading-relaxed">
                A five-chapter promise from author Damali Allison — the reason every
                Bailey adventure is written the way it is.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-8 flex flex-col">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.06}>
                <div
                  data-testid={`manifesto-chapter-${c.n}`}
                  className="group grid sm:grid-cols-[auto_1fr] gap-4 sm:gap-8 py-8 border-t border-sand last:border-b items-start hover:bg-white/50 transition-colors duration-300 rounded-xl px-3 -mx-3"
                >
                  <span className="font-mono font-bold text-4xl sm:text-5xl text-terracotta/80 group-hover:text-terracotta transition-colors leading-none">
                    {c.n}
                  </span>
                  <div>
                    <h3 className="font-display font-bold text-xl sm:text-2xl tracking-tight text-walnut mb-2">
                      {c.title}
                    </h3>
                    <p className="text-sm sm:text-base text-walnutsoft leading-relaxed max-w-xl">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
